import { hooks } from "./hookactions"
import { actions } from "./actions"
export let DATFeedback = { hooks, actions }
